import * as actionTypes from '../../types/settings/loading';

const initialState = {
  counter: 0,
  visibleProgressBar: false,
  countProgressBar: 0,
  countSK: 0
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.START_LOADING:
      return {
        ...state,
        counter: state.counter + 1
      };
    case actionTypes.STOP_LOADING:
      return {
        ...state,
        counter: state.counter - 1
      };
    case actionTypes.START_PROGRESS_BAR:
      return {
        ...state,
        visibleProgressBar: true,
        countSK: payload
      };
    case actionTypes.STOP_PROGRESS_BAR:
      return {
        ...state,
        visibleProgressBar: false,
        countSK: 0
      };
    case actionTypes.ADD_PROGRESS_BAR:
      return {
        ...state,
        countProgressBar: state.countProgressBar + 1
      };
    case actionTypes.CLEAR_PROGRESS_BAR:
      return {
        ...state,
        countProgressBar: 0
      };
    default:
      return state;
  }
};
export default reducer;
